import { DatePicker } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRpmCarePlanDailyTaskList,
  fetchRpmCarePlanTaskList,
} from "../../../../../../../Redux/actions/rpmActions";
import {
  convertToUTCDate,
  convertUTCDate,
} from "../../../../../../../utils/convertionFunc";
import rpmService from "../../../../../../../Services/rpmService";
import dayjs from "dayjs";

function UpdateDailyTask({ handleClose }) {
  const [loader, setLoader] = useState(false);
  const [enteredDate, setEnteredDate] = useState(dayjs());
  const { careTasksList, selectedRpmPatient } = useSelector(
    (state) => state.rpm
  );
  const dispatch = useDispatch();
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    const payload = {
      patientId: selectedRpmPatient.patientId,
      status: 1,
    };
    dispatch(fetchRpmCarePlanTaskList(payload));
  }, []);

  const concatDateWithCurrentTime = (date) => {
    if (!date) return null;

    const datePart = dayjs(date, "MM/DD/YYYY").format("YYYY-MM-DD");
    const timePart = dayjs().format("HH:mm:ss");

    return `${datePart} ${timePart}`;
  };

  const handleSubmitDailyTask = async (selectedItem, actionType) => {
    const finalPayloadArr = [];
    setLoader(true);
    const payload = {
      createdBy: loggedUser?.user?.userId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      description: selectedItem.taskDescription,
      // endCreatedTime: convertToUTCDate(selectedItem.toDate, "YYYY-MM-DD HH:mm:ss"),
      endCreatedTime: concatDateWithCurrentTime(selectedItem.toDate),
      frequencyCode: selectedItem.frequencyCode,
      frequencyName: selectedItem.frequencyName,
      givenDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedBy: loggedUser?.user?.userId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      enteredDate: convertUTCDate(enteredDate, "MM/DD/YYYY"),
      enteredOn: convertUTCDate(enteredDate, "YYYY-MM-DD HH:mm:ss"),
      patientId: selectedRpmPatient.patientId,
      // startCreatedTime:  convertToUTCDate(selectedItem.fromDate, "YYYY-MM-DD HH:mm:ss"),
      startCreatedTime: concatDateWithCurrentTime(selectedItem.fromDate),
      status: 1,
      taskCode: selectedItem.taskCode,
      taskName: selectedItem.taskName,
      taskTaken: actionType === "Yes" ? "Y" : "N",
      account_Id: selectedRpmPatient.account_Id,
      clinic_id: selectedRpmPatient.clinic_Id,
      userId: selectedRpmPatient.createdBy,
      patientTaskId: selectedItem.id,
    };
    finalPayloadArr.push(payload);

    try {
      await rpmService.updateCarePlanDailyTask(finalPayloadArr);
      const carePlanDailypayload = {
        patientId: selectedRpmPatient.patientId,
        status: 1,
      };
      dispatch(fetchRpmCarePlanDailyTaskList(carePlanDailypayload));
      setLoader(false);
      handleClose();
    } catch (e) {
      console.error(e);
      setLoader(false);
    }
  };

  const handleEnteredDate = (date) => {
    setEnteredDate(date);
  };

  return (
    <div>
      <div className="p-4">
        <div className="mb-4 w-96 flex gap-2 items-center">
          <label className="font-medium mb-1">Entered On:</label>
          <DatePicker onChange={handleEnteredDate} defaultValue={dayjs()} />
        </div>

        <div className="h-[400px] overflow-y-scroll scrollWidth space-y-4">
          {careTasksList.map((data, index) => (
            <div
              key={index}
              className="border rounded-lg border-gray-300 bg-white p-4 shadow-sm"
            >
              <div className="flex justify-between items-center mb-2">
                <h3 className="text-base font-bold text-gray-800">
                  {/* {data.taskName || data.taskCode} */}
                  {data.taskName?.trim() ? data.taskName : data.taskCode}
                </h3>
              </div>

              <p className="text-gray-600 text-sm mb-3">
                {data.taskDescription}
              </p>

              <div className="flex justify-between items-center text-sm text-gray-500 mb-3">
                <span className="font-semibold">{data.frequencyName}</span>
                <div className="flex gap-6">
                  <span>
                    <strong>From:</strong> {data.fromDate}
                  </span>
                  <span>
                    <strong>To:</strong> {data.toDate}
                  </span>
                </div>
              </div>

              <div className="flex justify-end gap-4">
                <button
                  disabled={loader}
                  className="border border-brand-primaryColor bg-white text-brand-primaryColor px-4 py-1.5 rounded text-sm disabled:cursor-not-allowed disabled:opacity-50"
                  onClick={() => handleSubmitDailyTask(data, "No")}
                >
                  No
                </button>
                <button
                  disabled={loader}
                  className="bg-brand-primaryColor text-white px-4 py-1.5 rounded text-sm disabled:cursor-not-allowed disabled:opacity-50"
                  onClick={() => handleSubmitDailyTask(data, "Yes")}
                >
                  Yes
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default UpdateDailyTask;
